import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getDayTypes,
  getLocales,
  getRoutesStops,
  getTranRoutes,
  getTranTypes,
} from '../../api/select'

export const fetchTranTypes = createAsyncThunk('fetchTranTypes', async (params, thunkAPI) => {
  const data = await getTranTypes()
  // console.log(data)
  return data
})

export const fetchDayTypes = createAsyncThunk('fetchDayTypes', async (params, thunkAPI) => {
  const data = await getDayTypes()
  // console.log(data)
  return data
})

export const fetchTranRoutes = createAsyncThunk(
  'fetchTranRoutes',
  async (params, thunkAPI) => {
    const {
      select: {
        currentTransport: { type_id },
      },
    } = thunkAPI.getState()
    // console.log({ type_id })

    const data = await getTranRoutes({ transport_type_id: type_id })
    // console.log(data)
    return data
  },
)

export const fetchRoutesStops = createAsyncThunk(
  'fetchRoutesStops',
  async (params, thunkAPI) => {
    // console.log(params)
    const { route_id, direction = 'forward' } = params
    if (!route_id) {
      throw Error('route_id is required')
    }

    const data = await getRoutesStops({ route_id, direction })
    // console.log(data)
    return data
  },
)

export const fetchLocales = createAsyncThunk('fetchLocales', async (params, thunkAPI) => {
  const data = await getLocales()
  // console.log(data)
  return data
})
